import React from 'react';
import { Card, Typography, Box, Button } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import PlateTextField from 'src/components/widgets/plate-textfield'
import ReadOnlyTextFields from 'src/components/widgets/readonly-textfields'
import { nextNavigate } from 'src/utils/navigation-utils';
import { useRouter } from 'src/hooks/use-router';
import { paths } from 'src/paths';
import { useTranslation } from 'react-i18next';
import { appStr } from 'src/locales/app_strings';

export const OrdersView = ({ myOrders }) => {
  const { t } = useTranslation();
  const router = useRouter();

  const detailClicked = () => {
    nextNavigate(
      router,
      null,
      paths.orders.details,
      paths.dashboard.index,
    );
  }

  const sessionClicked = () => {
    nextNavigate(
      router,
      null,
      paths.sessions.details,
      paths.dashboard.index,
    );
  }

  return (
    <Box component="main" sx={{ flexGrow: 1, px: 0}}>
      {myOrders.map((item, index) => (
        <Card
          key={index}
          sx={{
            mb: 2,
            p: 1,
            boxShadow: 1,
            border: '2px solid',
            borderColor: `${item.color}`,
          }}
        >
          <Grid container spacing={2}>
            <Grid xs={12} md={12}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Button variant="outlined"
                  onClick={detailClicked}
                  sx={{
                    borderColor: 'primary.main',
                    color: 'text.primary',
                    fontSize: '1em',
                    '&:hover': {
                      borderColor: 'primary.dark',
                      backgroundColor: 'transparent',
                    },
                    p: 1
                  }}
                  >
                  {item.from} - {item.to}
                </Button>
                <Typography sx={{ fontSize: '1em', color: 'text.secondary' }}>
                  {item.studentPhone}
                </Typography>
              </Box>
            </Grid>
            
            <Grid xs={12} md={12}>
              <ReadOnlyTextFields
                label="Giáo viên"
                value={[item.teacherCode, item.teacher]}
              />
            </Grid>

            <Grid xs={12} md={12}>
              <ReadOnlyTextFields
                label="Học viên"
                value={[item.studentCode, item.student]}
              />
            </Grid>
            
            <Grid xs={12} md={12}>
              <ReadOnlyTextFields
                label={t(appStr.txt_073)}
                value={[item.courseType, item.course]}
              />
            </Grid>
            
            <Grid xs={12} md={12}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <PlateTextField transmission={`${item.carType}`} plate={`${item.carPlate}`} />
                <Button variant="contained" onClick={sessionClicked}>Kết phiên</Button>
              </Box>
            </Grid>

          </Grid>
        </Card>
      ))}
    </Box>
  );
};

export default OrdersView;
